<template>
  <collapsible-widget
    title="ZGŁOŚ ROZBIEŻNOŚĆ"
    :accordion="accordion"
    :default-expanded="true"
  >
    <b-form id="mismatch-application-form">
      <span class="mb-2"><strong>Wprowadź zakres rozbieżności</strong></span>
      <b-alert variant="danger" :show="mismatchHasError"
        ><strong>Uwaga.</strong> Formularz zawiera błędy lub na mapie nie
        zostały zaznaczone rozbieżności.</b-alert
      >
      <b-form-group class="mt-2">
        <b-button-group class="d-flex w-100  flex-wrap">
          <b-button
            :variant="mismatchObjectsModeEnabled ? 'success' : 'primary'"
            @click="setObjectsModeActive"
            >{{
              isMobileDevice ? 'Zaznacz obiekt' : 'Zaznacz obiekty'
            }}</b-button
          >
          <b-button
            class="mt-2 mb-2"
            :variant="mismatchPointModeEnabled ? 'success' : 'primary'"
            @click="setPointsModeActive"
            v-if="!isMobileVersion"
            >Wstaw punkt</b-button
          >
          <b-button
            :variant="mismatchAreaModeEnabled ? 'success' : 'primary'"
            @click="setAreaModeActive"
            v-if="!isMobileVersion"
            >Rysuj obszar</b-button
          >
        </b-button-group>
      </b-form-group>
      <b-form-group v-if="mismatchObjectsModeEnabled">
        <span>Zaznaczone obiekty: {{ selectedObjectsCounter }}</span>
        <b-link href="#" class="float-right" @click="clearObjects()"
          >Zmień</b-link
        >
      </b-form-group>
      <b-form-group v-if="mismatchPointModeEnabled && isPointSelected">
        <span>Wybrano: {{ selectedPointCoordinates }}</span>
        <b-link href="#" class="float-right" @click="clearPoint()"
          >Zmień</b-link
        >
      </b-form-group>
      <b-form-group v-if="mismatchAreaModeEnabled && isAreaSelected">
        <span>Wybrano obszar</span>
        <b-link href="#" class="float-right" @click="clearArea()">Zmień</b-link>
      </b-form-group>
      <b-form-group
        v-if="mismatchPointModeEnabled || mismatchAreaModeEnabled"
        label="Warstwy"
        label-for="layers-multiselect"
      >
        <small class="text-danger" v-show="errors.layerNotSelected"
          >Należy wybrać przynajmniej jedną warstwę.</small
        >
        <div
          class="col-md-12 p-0"
          :class="{ 'has-error': errors.layerNotSelected }"
        >
          <multiselect
            id="layers-multiselect"
            v-model="selectedLayers"
            :options="layers"
            :multiple="true"
            :class="{ 'is-invalid': errors.layerNotSelected }"
            :close-on-select="false"
            :hide-selected="true"
            :searchable="true"
            select-label="Kliknij aby wybrać"
            selected-label="Wybrano"
            deselect-label="Kliknij aby usunąć"
            placeholder="Wybierz warstwy"
            label="text"
            track-by="value"
          >
            <template slot="noResult">
              Nie znaleziono elementów
            </template>
          </multiselect>
        </div>
      </b-form-group>
      <b-form-group
        :label="isMobileDevice ? '' : 'Tytuł'"
        label-for="title-input"
      >
        <small class="text-danger" v-show="errors.titleIsEmpty"
          >Należy podać tytuł.</small
        >
        <b-form-input
          id="title-input"
          :placeholder="isMobileDevice ? 'Tytuł' : 'Wpisz'"
          v-model="title"
          @click="showTitleContextAssistant"
          :class="{ 'is-invalid': errors.titleIsEmpty, 'form-control': true }"
        ></b-form-input>
      </b-form-group>
      <b-form-group
        :label="isMobileDevice ? '' : 'Opis'"
        label-for="description-input"
      >
        <small class="text-danger" v-show="errors.descriptionIsEmpty"
          >Należy podać opis.</small
        >
        <b-form-textarea
          :placeholder="isMobileDevice ? 'Opis' : 'Wpisz'"
          :rows="3"
          v-model="description"
          @click="showDescriptionContextAssistant"
          :class="{
            'is-invalid': errors.descriptionIsEmpty,
            'form-control': true
          }"
        ></b-form-textarea>
      </b-form-group>
      <b-form-group
        :label="isMobileDevice ? '' : 'Podmiot weryfikujący zgłoszenie'"
        label-for="organization-input"
      >
        <div @click="showOrganizationContextAssistant">
          <small class="text-danger" v-show="errors.organizationNotSelected"
            >Należy podać podmiot do którego zgłoszona zostanie
            rozbieżność.</small
          >
          <autocomplete
            ref="organizationSearchQuery"
            id="organization-search-query-autocomplete"
            v-model="organizationSearchQuery"
            :items="organizationAutocompleteItems"
            @update-items="organizationAutocompleteUpdated"
            :min-len="3"
            :input-attrs="{
              placeholder: isMobileDevice
                ? 'Podmiot weryfikujący zgłoszenie'
                : 'Wyszukaj',
              class: 'form-control'
            }"
            :auto-select-one-item="false"
          >
          </autocomplete>
        </div>
      </b-form-group>
      <b-form-group>
        <b-button-group class="w100">
          <b-button
            :disabled="mismatchLoading"
            variant="primary"
            class="col-md-6"
            @click="send()"
          >
            <span v-if="!mismatchLoading">Zgłoś</span>
            <span v-else><icon name="circle-notch" spin/></span>
          </b-button>
          <b-button
            :disabled="mismatchLoading"
            variant="outline-secondary"
            class="col-md-6"
            @click="exit()"
          >
            <span v-if="!mismatchLoading">Anuluj</span>
            <span v-else><icon name="circle-notch" spin/></span>
          </b-button>
        </b-button-group>
      </b-form-group>
    </b-form>
    <loading-overlay
      :active.sync="isLoading"
      :is-full-page="false"
    ></loading-overlay>
  </collapsible-widget>
</template>

<script>
import Autocomplete from 'v-autocomplete';
// import AutocompleteItem from './AutocompleteItem.vue';
import { Api as UsersApi } from '../api/api-uzytkownicy.js';
import { Api as LayersApi } from '../api/api-warstwy.js';
import LoadingOverlay from 'vue-loading-overlay';
import { mapGetters } from 'vuex';
import { createStringXY } from 'ol/coordinate';
import GeoJSONFormat from 'ol/format/GeoJSON';
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
import LineString from 'ol/geom/LineString';
import Polygon from 'ol/geom/Polygon';
import {
  MAP_SELECTION_APPLY,
  MISMATCH_SAVE,
  DISPLAY_CONTEXT_ASSISTANT_MESSAGE
} from '../store/actions.type';
import {
  SELECT_FEATURE_POPUP_HIDE,
  MISMATCH_AREA_MODE_ENABLED,
  MISMATCH_POINT_MODE_ENABLED,
  MISMATCH_OBJECTS_MODE_ENABLED,
  MISMATCH_DISABLE_MODES,
  MISMATCH_AREA_SET,
  MISMATCH_POINT_SET,
  MISMATCH_OBJECTS_SET,
  WINDOW_API_ERROR_SHOW,
  LEFT_RESIZABLE_PANEL_EXPAND_CHANGE
} from '../store/mutations.type';
import CollapsibleWidget from './CollapsibleWidget';
export default {
  name: 'MismatchApplication',
  props: {
    accordion: {
      type: String,
      default: 'panel'
    }
  },
  components: {
    Autocomplete,
    CollapsibleWidget,
    LoadingOverlay
  },
  data() {
    return {
      isLoading: false,
      objectsMode: {
        selectedCounter: this.selectedObjectsCounter,
        active: false
      },
      pointsMode: {
        active: false
      },
      areaMode: {
        active: false
      },
      layers: [],
      selectedLayers: [],
      title: '',
      description: '',

      organization: '',
      organizationSearchQuery: null,
      organizationAutocompleteItems: [],
      errors: {
        titleIsEmpty: false,
        descriptionIsEmpty: false,
        organizationNotSelected: false,
        layerNotSelected: false,
        mismatchNotSelected: false
      },
      mismatchHasError: false,
      mismatchLoading: false
    };
  },
  mounted() {
    this.loadLayers();
  },
  computed: {
    ...mapGetters([
      'selectedMapFeatures',
      'mismatchObjectsModeEnabled',
      'mismatchPointModeEnabled',
      'mismatchAreaModeEnabled',
      'mismatchAreaFeatures',
      'mismatchPointFeatures',
      'mismatchObjectsFeatures',
      'featuresLayer',
      'selectedFeatures',
      'isMobileDevice',
      'isMobileVersion',
      'contextAssistantActive'
    ]),
    selectedObjectsCounter() {
      return this.selectedMapFeatures.size;
    },
    isAreaSelected() {
      return this.mismatchAreaFeatures != null;
    },
    isPointSelected() {
      return this.mismatchPointFeatures != null;
    },
    selectedPointCoordinates() {
      if (this.mismatchPointFeatures != null) {
        var coordinates = this.mismatchPointFeatures
          .getGeometry()
          .getCoordinates();
        var stringifyFunction = createStringXY(2);
        return stringifyFunction(coordinates);
      }
      return '';
    }
  },
  watch: {
    organizationSearchQuery(newVal) {
      if (newVal) {
        this.organization = this.organizations.find(el => {
          return this.organizationSearchQuery === el.name;
        }).id;
      } else {
        this.organization = null;
      }
    },
    selectedMapFeatures(newVal) {
      if (newVal && this.isMobileDevice) {
        this.$store.commit(LEFT_RESIZABLE_PANEL_EXPAND_CHANGE, true);
      }
    }
  },
  methods: {
    setObjectsModeActive() {
      if (this.contextAssistantActive) {
        this.$store.dispatch(DISPLAY_CONTEXT_ASSISTANT_MESSAGE, {
          message:
            'Naciśnięcie tego przycisku pokaże mapę na której należy wybrać obiekt który chcemy zgłosić w ramach operacji zgłoszenia rozbieżności. Po wybraniu obiektu ponownie pokaże się okno operacji zgłaszania rozbieżności.'
        });
      } else {
        if (!this.mismatchObjectsModeEnabled) {
          this.clearPoint();
          this.clearArea();
          this.$store.commit(MISMATCH_OBJECTS_MODE_ENABLED);
          this.clearNotifications();
          this.showObjectsNotification();
          this.clearErrors();
        }
        if (this.isMobileDevice) {
          this.$store.commit(LEFT_RESIZABLE_PANEL_EXPAND_CHANGE, false);
        }
      }
    },
    setPointsModeActive() {
      if (!this.mismatchPointModeEnabled) {
        this.clearObjects();
        this.clearArea();
        this.$store.commit(MISMATCH_POINT_MODE_ENABLED);
        this.clearNotifications();
        this.showPointNotification();
        this.clearErrors();
      }
    },
    setAreaModeActive() {
      if (!this.mismatchAreaModeEnabled) {
        this.clearObjects();
        this.clearPoint();
        this.$store.commit(MISMATCH_AREA_MODE_ENABLED);
        this.clearNotifications();
        this.showAreaNotification();
        this.clearErrors();
      }
    },
    clearObjects() {
      this.$store.commit(SELECT_FEATURE_POPUP_HIDE);
      this.$store.dispatch(MAP_SELECTION_APPLY);
      this.$store.commit(MISMATCH_OBJECTS_SET, null);
    },
    clearPoint() {
      this.$emit('mistmachLayerClear');
      this.$store.commit(MISMATCH_POINT_SET, null);
    },
    clearArea() {
      this.$emit('mistmachLayerClear');
      this.$store.commit(MISMATCH_AREA_SET, null);
    },
    async send() {
      if (this.contextAssistantActive) {
        this.$store.dispatch(DISPLAY_CONTEXT_ASSISTANT_MESSAGE, {
          message:
            'Przycisk "Zgłoś" uruchomi operację zgłoszenia rozbieżności. Przed zgłoszeniem rozbieżności upewnij się że formularz został poprawnie uzupełniony.'
        });
      } else {
        if (this.validate()) {
          this.mismatchLoading = true;
          var geojson = this.getGeojson();
          var type = this.getType();
          var layerIds = this.getLayerIds();

          var mismatchObject = {
            geojson: geojson,
            opis: this.description,
            tytul: this.title,
            podmiot_weryfikujacy: this.organization,
            typ: type,
            warstwa_ids: layerIds
          };

          const response = await this.$store.dispatch(MISMATCH_SAVE, {
            mismatchObject,
            wso2_id: this.contextEmail,
            orgid: this.contextOrganizationId
          });
          if (response === true) {
            this.mismatchLoading = false;
            this.cancel();
            this.$notify({
              type: 'success',
              title: 'Sukces!',
              text: 'Rozbieżność została zgłoszona poprawnie.',
              duration: 2000
            });
          } else if (response === false) {
            this.mismatchLoading = false;
            this.$notify({
              type: 'error',
              title: 'Uwaga!',
              text: 'Wystąpił błąd podczas zgłaszania rozbieżności.',
              duration: 2000
            });
          }
        }
      }
    },
    getGeojson() {
      var features = [];
      if (this.mismatchObjectsModeEnabled) {
        features = this.getSelectedFeaturesArray();
      } else if (this.mismatchPointModeEnabled) {
        features = [this.mismatchPointFeatures];
      } else if (this.mismatchAreaModeEnabled) {
        features = [this.mismatchAreaFeatures];
      }
      if (features.length > 0) {
        var geojson = new GeoJSONFormat().writeFeaturesObject(features, {
          featuresProjection: 'EPSG:2180',
          dataProjection: this.$store.getters.coordinateSystem
        });
        return geojson;
      }
      return null;
    },
    getType() {
      if (this.mismatchObjectsModeEnabled) {
        return 'obiekty';
      } else if (this.mismatchPointModeEnabled) {
        return 'punkty';
      } else if (this.mismatchAreaModeEnabled) {
        return 'obszar';
      }
      return '';
    },
    getLayerIds() {
      if (this.mismatchObjectsModeEnabled) {
        return [this.featuresLayer.id];
      } else if (
        this.mismatchPointModeEnabled ||
        this.mismatchAreaModeEnabled
      ) {
        return this.selectedLayers.map(x => x.value);
      }
      return [];
    },
    getSelectedFeaturesArray() {
      var self = this;
      let typ = this.featuresLayer.type;
      var features = [];
      this.selectedFeatures.forEach(function(obj) {
        switch (typ) {
          case 'point':
            var feature = new Feature({
              geometry: new Point(
                obj.geometry
                  ? obj.geometry.coordinates
                  : self.createPointCoordinatesFromFlatCoordinates(
                      obj.flatCoordinates
                    )
              )
            });
            feature.setId(obj.id);
            features.push(feature);
            break;
          case 'polygon':
            var feature = new Feature({
              geometry: new Polygon(
                obj.geometry
                  ? obj.geometry.coordinates
                  : self.createPolygonCoordinatesFromFlatCoordinates(
                      obj.flatCoordinates
                    )
              )
            });
            feature.setId(obj.id);
            features.push(feature);
            break;
          case 'linestring':
            var feature = new Feature({
              geometry: new LineString(
                obj.geometry
                  ? obj.geometry.coordinates
                  : self.createLinestringCoordinatesFromFlatCoordinates(
                      obj.flatCoordinates
                    )
              )
            });
            feature.setId(obj.id);
            features.push(feature);
            break;
        }
      });
      return features;
    },
    cancel() {
      if (this.mismatchObjectsModeEnabled) {
        this.clearObjects();
      } else if (this.mismatchPointModeEnabled) {
        this.clearPoint();
      } else if (this.mismatchAreaModeEnabled) {
        this.clearArea();
      }
      this.clearNotifications();
      this.clearInputs();
      this.$emit('mismatchEndInteraction');
      this.$store.commit(MISMATCH_DISABLE_MODES);
    },
    exit() {
      if (this.contextAssistantActive) {
        this.$store.dispatch(DISPLAY_CONTEXT_ASSISTANT_MESSAGE, {
          message:
            'Przycisk "Anuluj" wyczyści formularz i wyłączy narzędzie zgłaszania rozbieżności.'
        });
      } else {
        this.$emit('mismatchCancel');
      }
    },
    clearNotifications() {
      this.$notify({
        clean: true
      });
    },
    clearInputs() {
      this.selectedLayers = [];
      this.title = '';
      this.description = '';
      this.organization = '';
    },
    showObjectsNotification() {
      this.$notify({
        type: 'info',
        title: 'Informacja.',
        text:
          'Wybierz obiekty w widoku mapy, które podlegają rozbieżności przy użyciu selekcji elementów.',
        duration: 10000
      });
    },
    showPointNotification() {
      this.$notify({
        type: 'info',
        title: 'Informacja.',
        text: 'Wybierz obszar w widoku mapy, aby wstawić punkt.',
        duration: 10000
      });
    },
    showAreaNotification() {
      this.$notify({
        type: 'info',
        title: 'Informacja.',
        text:
          'Wybierz kolejne punkty obszaru na mapie, aby zakończyć wybierz dwukrotnie widok mapy.',
        duration: 10000
      });
    },
    loadLayers() {
      var self = this;
      var api = new LayersApi();
      self.isLoading = true;

      let layersNames = [
        {
          name: 'Infrastruktura techniczna - punktowa',
          newName:
            'Infrastruktura techniczna i kanały technologiczne - punktowa'
        },
        {
          name: 'Infrastruktura techniczna - liniowa',
          newName: 'Infrastruktura techniczna i kanały technologiczne - liniowa'
        },
        {
          name: 'Infrastruktura techniczna - powierzchniowa',
          newName:
            'Infrastruktura techniczna i kanały technologiczne - powierzchniowa'
        },
        {
          name: 'Roboty budowlane - infrastruktura punktowa',
          newName: 'Plany inwestycyjne – infrastruktura punktowa'
        },
        {
          name: 'Roboty budowlane - infrastruktura liniowa',
          newName: 'Plany inwestycyjne – infrastruktura liniowa'
        },
        {
          name: 'Roboty budowlane - infrastruktura powierzchniowa',
          newName: 'Plany inwestycyjne – infrastruktura powierzchniowa'
        }
      ];

      api
        .getWarstwy({
          wso2_id: this.contextEmail,
          orgid: this.contextOrganizationId,
          systemowa: true
        })
        .then(function(response) {
          self.layers = response.body.warstwy.map(x => {
            return {
              text:
                !layersNames.filter(z => z.name == x.nazwa).length > 0
                  ? x.nazwa
                  : layersNames.filter(z => z.name == x.nazwa)[0].newName,
              value: x.id
            };
          });

          self.isLoading = false;
        })
        .catch(function(response) {
          self.isLoading = false;
          self.$store.commit(WINDOW_API_ERROR_SHOW);
        });
    },
    validate() {
      this.mismatchHasError = false;
      if (
        this.mismatchObjectsModeEnabled ||
        this.mismatchPointModeEnabled ||
        this.mismatchAreaModeEnabled
      ) {
        this.errors.titleIsEmpty = !this.title;
        this.errors.descriptionIsEmpty = !this.description;
        this.errors.organizationNotSelected = !this.organization;
        this.errors.layerNotSelected = this.mismatchObjectsModeEnabled
          ? false
          : this.selectedLayers.length == 0;
        // czy zaznaczono rozbieznosci
        if (this.mismatchObjectsModeEnabled) {
          this.errors.mismatchNotSelected = this.selectedObjectsCounter == 0;
        } else if (this.mismatchPointModeEnabled) {
          this.errors.mismatchNotSelected = this.mismatchPointFeatures == null;
        } else if (this.mismatchAreaModeEnabled) {
          this.errors.mismatchNotSelected = this.mismatchAreaFeatures == null;
        }

        this.mismatchHasError =
          this.errors.titleIsEmpty ||
          this.errors.descriptionIsEmpty ||
          this.errors.organizationNotSelected;
        this.errors.layerNotSelected || this.errors.mismatchNotSelected;

        return !this.mismatchHasError;
      }
      this.mismatchHasError = true;
      return false;
    },
    clearErrors() {
      this.mismatchHasError = false;
      this.errors.titleIsEmpty = false;
      this.errors.descriptionIsEmpty = false;
      this.errors.organizationNotSelected = false;
      this.errors.layerNotSelected = false;
      this.errors.mismatchNotSelected = false;
    },
    createPointCoordinatesFromFlatCoordinates(flatCoordinates) {
      var coordinates = [];
      flatCoordinates.forEach(function(coord) {
        coordinates.push(coord);
      });
      return coordinates;
    },
    createLinestringCoordinatesFromFlatCoordinates(flatCoordinates) {
      var coordinates = [];
      var coordXY = [];
      flatCoordinates.forEach(function(coord) {
        coordXY.push(coord);
        if (coordXY.length == 2) {
          coordinates.push(coordXY);
          coordXY = [];
        }
      });
      return coordinates;
    },
    createPolygonCoordinatesFromFlatCoordinates(flatCoordinates) {
      var coordinates = [];
      var coordXY = [];
      flatCoordinates.forEach(function(coord) {
        coordXY.push(coord);
        if (coordXY.length == 2) {
          coordinates.push(coordXY);
          coordXY = [];
        }
      });
      return [coordinates];
    },
    async organizationAutocompleteUpdated(text) {
      if (text) {
        try {
          const api = new UsersApi();

          const response = await api.getCboOrganizations({
            wso2_id: this.contextEmail,
            orgid: this.contextOrganizationId,
            filter_str: text
          });

          if (response) {
            this.organizations = response.body.organizations;
            this.organizationAutocompleteItems = response.body.organizations.map(
              u => {
                return u.name;
              }
            );
          }
        } catch (error) {
          this.$notify({
            type: 'error',
            title: 'Uwaga!',
            text: error,
            duration: 10000
          });
        }
      }
    },
    showTitleContextAssistant() {
      if (this.contextAssistantActive) {
        this.$store.dispatch(DISPLAY_CONTEXT_ASSISTANT_MESSAGE, {
          message: 'W polu "Tytuł" należy wpisać tytuł zgłoszenia.'
        });
      }
    },
    showDescriptionContextAssistant() {
      if (this.contextAssistantActive) {
        this.$store.dispatch(DISPLAY_CONTEXT_ASSISTANT_MESSAGE, {
          message:
            'W polu "Opis" należy wpisać opis zgłoszenia (precyzyjny i szczegółowy opisz przyczyni się do szybszego rozwiązania problemu).'
        });
      }
    },
    showOrganizationContextAssistant() {
      if (this.contextAssistantActive) {
        this.$store.dispatch(DISPLAY_CONTEXT_ASSISTANT_MESSAGE, {
          message:
            'W polu "Podmiot weryfikujący zgłoszenie" należy wpisać podmiot (organizację) która ma zająć się danym zgłoszeniem (wybranie odpowiedniego podmiotu przyczyni się do szybszego rozwiązania problemu).'
        });
      }
    }
  }
};
</script>

<style>
#mismatch-application-form {
  padding-left: 1em;
  padding-right: 1em;
}

.w100 {
  width: 100%;
}
</style>
